import { useTranslation } from 'react-i18next';

import { PiArrowLeft, PiTrash } from 'react-icons/pi';

import QuickActionsModal from '@/components/dashboard/QuickActionsModal/QuickActionsModal';

export interface MonthToDelete {
  monthIndex: number;
  name: string;
}

interface DeleteMonthModalProps {
  month: MonthToDelete | null;
  confirmText: string;
  warningText: string;
  onConfirm: () => void;
  onClose: () => void;
}

export const DeleteMonthModal = ({ month, confirmText, warningText, onConfirm, onClose }: DeleteMonthModalProps) => {
  const { t } = useTranslation();

  const actions = [
    {
      icon: <div className='w-10 h-10 flex items-center justify-center bg-red-300 rounded-full'>
        <PiTrash className="w-5 h-5 text-[#1D2233]" />
      </div>,
      text: confirmText,
      subtext: warningText,

      onClick: onConfirm,
      className: "rounded-t-3xl rounded-b-xl"
    },
    {
      icon: <div className='w-10 h-10 flex items-center justify-center bg-slate-100 rounded-full'>
        <PiArrowLeft className="w-5 h-5 text-[#1D2233]" />
      </div>,
      text: t('profile.goBack'),
      subtext: "",

      onClick: onClose,
      className: "rounded-b-3xl rounded-t-xl"
    },
  ];

  return (
    <QuickActionsModal
      actions={actions}
      isOpen={month !== null}
      setOpen={onClose}
    />
  );
};

export default DeleteMonthModal;
